// ------------------------------------
// Constants
// ------------------------------------
// prettier-ignore
export const ADDRESSES_PUT_REQUEST = 'ADDRESSES_PUT_REQUEST';
// prettier-ignore
export const ADDRESSES_PUT_REQUEST_SUCCESS = 'ADDRESSES_PUT_REQUEST_SUCCESS';
// prettier-ignore
export const ADDRESSES_PUT_REQUEST_FAILURE = 'ADDRESSES_PUT_REQUEST_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------
export function request(payload, resolve, reject) {
  return {
    type: ADDRESSES_PUT_REQUEST,
    payload,
    resolve,
    reject,
  };
}

export function requestSuccess(payload, data) {
  return {
    type: ADDRESSES_PUT_REQUEST_SUCCESS,
    payload,
    data,
  };
}

export function requestFailure(payload, error) {
  return {
    type: ADDRESSES_PUT_REQUEST_FAILURE,
    payload,
    error,
  };
}
